// extracted by mini-css-extract-plugin
export default {"loadingPage":"loading_loadingPage__8ka8C","dot":"loading_dot__XiaBC","bounce":"loading_bounce__3GKhY"};